import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";

const transactions = [
  { name: "Transfer From Avila Leonel G...", date: "Mar 14", category: "Others", amount: "-$145.20", color: "#EF4444" },
  { name: "Transfer To Franco", date: "Mar 14", category: "Others", amount: "-$165.35", color: "#EF4444" },
  { name: "Zelle Transfer To Franco", date: "Mar 14", category: "Others", amount: "-$234.76", color: "#EF4444" },
  { name: "Transfer To Franco", date: "Mar 14", category: "Others", amount: "-$175.20", color: "#EF4444" },
  { name: "Transfer From Avila Leonel G...", date: "Mar 14", category: "Others", amount: "-$198.20", color: "#EF4444" },
];

export const AmericanNewCardDetail = () => {
  const colors = useDynamicColors();
  const location = useLocation();
  const navigate = useNavigate();

  const handleBack = () => {
    const currentParams = location.search;
    navigate(`/regional-landing-americannew-mobile${currentParams}`);
  };

  const handleLogout = () => {
    const currentParams = location.search;
    navigate(`/regional-login-americannew-mobile${currentParams}`);
  };

  return (
    <div className="ancd-wrapper">
      <div className="ancd-container">
        {/* Header */}
        <div className="ancd-header" style={{ backgroundColor: colors.cuaternario }}>
          <div className="ancd-header-row">
            <div className="ancd-back" onClick={handleBack}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <span className="ancd-header-title">Account Details</span>
            {colors.url_logo ? (
              <img src={colors.url_logo} alt="Logo" className="ancd-header-logo" />
            ) : (
              <div style={{ width: 24 }} />
            )}
          </div>
        </div>

        {/* Scrollable Content */}
        <div className="ancd-content">
          {/* Account Card */}
          <div className="ancd-account-card" style={{ backgroundColor: colors.primario }}>
            <div className="ancd-account-top">
              <span className="ancd-account-type">Savings Account</span>
              <span className="ancd-account-number">**** **** **** 9674</span>
            </div>
            <div className="ancd-account-balance">
              <span className="ancd-currency">USD</span>
              <span className="ancd-amount">$5,532</span>
              <span className="ancd-cents">.11</span>
            </div>
            <div className="ancd-exp">Exp. 06/2028</div>

            {/* Quick Actions */}
            <div className="ancd-quick-actions">
              <div className="ancd-qa-item">
                <div className="ancd-qa-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="3" y="11" width="18" height="11" rx="2" stroke="white" strokeWidth="2"/>
                    <path d="M7 11V7a5 5 0 0110 0v4" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                </div>
                <span className="ancd-qa-label">Freeze</span>
              </div>
              <div className="ancd-qa-item">
                <div className="ancd-qa-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 7h3a5 5 0 010 10h-3M9 17H6a5 5 0 010-10h3M8 12h8" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                </div>
                <span className="ancd-qa-label">Change PIN</span>
              </div>
              <div className="ancd-qa-item">
                <div className="ancd-qa-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="2"/>
                    <path d="M12 8v8M8 12h8" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                </div>
                <span className="ancd-qa-label">Add Money</span>
              </div>
              <div className="ancd-qa-item">
                <div className="ancd-qa-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <span className="ancd-qa-label">Send</span>
              </div>
              <div className="ancd-qa-item">
                <div className="ancd-qa-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22 12h-4l-3 9L9 3l-3 9H2" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <span className="ancd-qa-label">Stats</span>
              </div>
            </div>
          </div>

          {/* Account Info Card */}
          <div className="ancd-info-card">
            <div className="ancd-info-row">
              <span className="ancd-info-label">Account Number</span>
              <span className="ancd-info-value">**** **** **** 9674</span>
            </div>
            <div className="ancd-info-divider" />
            <div className="ancd-info-row">
              <span className="ancd-info-label">Status</span>
              <span className="ancd-info-status" style={{ color: colors.primario }}>Active</span>
            </div>
          </div>

          {/* Transactions */}
          <div className="ancd-section">
            <h2 className="ancd-section-title" style={{ color: colors.primario }}>Transactions</h2>
            <div className="ancd-tx-list">
              {transactions.map((tx, index) => (
                <div key={index} className="ancd-tx-item">
                  <div className="ancd-tx-icon" style={{ backgroundColor: colors.primario }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="12" r="1.5" fill="white"/>
                      <circle cx="6" cy="12" r="1.5" fill="white"/>
                      <circle cx="18" cy="12" r="1.5" fill="white"/>
                    </svg>
                  </div>
                  <div className="ancd-tx-info">
                    <span className="ancd-tx-name">{tx.name}</span>
                    <span className="ancd-tx-date">{tx.date} · {tx.category}</span>
                  </div>
                  <div className="ancd-tx-right">
                    <span className="ancd-tx-amount" style={{ color: tx.color }}>{tx.amount}</span>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 18l6-6-6-6" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Navigation */}
        <div className="ancd-bottom-nav">
          <div className="ancd-nav-item active">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" fill={colors.primario} stroke={colors.primario} strokeWidth="2"/>
            </svg>
            <span style={{ color: colors.primario }}>Home</span>
          </div>
          <div className="ancd-nav-item">
            <div className="ancd-nav-circle" style={{ backgroundColor: '#7C3AED' }}>
              <svg width="18" height="18" viewBox="0 0 59.1 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M58.7,83.4c-0.1-0.1-0.1-0.1-0.2-0.2l-0.1-0.1c-2.7-2.8-4.8-6.1-6.4-9.8c-0.2-0.6-0.8-1-1.4-1h-1.3h-5.8H20.6l36.6-46.9c0.2-0.3,0.3-0.6,0.3-1v-9.1c0-0.9-0.7-1.6-1.6-1.6H38.8h-0.7h-2V0.8c0-0.4-0.4-0.8-0.8-0.8H35h-0.3H23.9h-0.4h-0.3c-0.4,0-0.8,0.4-0.8,0.8v13.1h-2.8H19H3.1c-0.9,0-1.6,0.7-1.6,1.6V26c0,0.9,0.7,1.6,1.6,1.6h33.6L0.3,74C0.1,74.3,0,74.7,0,75v9.5c0,0.9,0.7,1.6,1.6,1.6h20.9v13.1c0,0.4,0.4,0.8,0.8,0.8h0.3H24h10.8H35h0.4c0.4,0,0.8-0.4,0.8-0.8V86.1H45h11.3h1.3c0.6,0,1.2-0.4,1.4-1C59.3,84.6,59.1,83.9,58.7,83.4" fill="white"/>
              </svg>
            </div>
            <span>Zelle</span>
          </div>
          <div className="ancd-nav-item">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span>Deposit</span>
          </div>
          <div className="ancd-nav-item">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="#9CA3AF" strokeWidth="2"/>
              <path d="M2 12h20M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z" stroke="#9CA3AF" strokeWidth="2"/>
            </svg>
            <span>Global</span>
          </div>
          <div className="ancd-nav-item" onClick={handleLogout} style={{ cursor: 'pointer' }}>
            <div className="ancd-nav-logout">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <span style={{ color: '#EF4444' }}>Log out</span>
          </div>
        </div>
      </div>
    </div>
  );
};
